"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reduxDevtools = require("redux-devtools");

var _reduxDevtoolsLogMonitor = _interopRequireDefault(require("redux-devtools-log-monitor"));

var _reduxDevtoolsDockMonitor = _interopRequireDefault(require("redux-devtools-dock-monitor"));

var _reduxDevtoolsDispatch = _interopRequireDefault(require("redux-devtools-dispatch"));

var _reduxDevtoolsMultipleMonitors = _interopRequireDefault(require("redux-devtools-multiple-monitors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actionCreators = {};

var _default = (0, _reduxDevtools.createDevTools)(_react.default.createElement(_reduxDevtoolsDockMonitor.default, {
  toggleVisibilityKey: "ctrl-h",
  defaultIsVisible: false,
  changePositionKey: "ctrl-q"
}, _react.default.createElement(_reduxDevtoolsMultipleMonitors.default, null, _react.default.createElement(_reduxDevtoolsLogMonitor.default, {
  theme: "tomorrow"
}), _react.default.createElement(_reduxDevtoolsDispatch.default, {
  actionCreators: actionCreators
}))));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/app/DevTools.js
// module id = 112
// module chunks = 0